import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {PageType, type Cta} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";
import {findPageIdByTypeInConfig} from "~/workspaceConfig/configPageIds";

type TransferPagesSlice = {pages: Record<string, {id: string; type: string}>};
type TransferCtasSlice = {ctas: Record<string, Cta>};

export function findTransferFormPageId(config: TransferPagesSlice): Uuid | undefined {
    const pageId = findPageIdByTypeInConfig(config, PageType.TransferForm);
    return pageId as Uuid | undefined;
}

export function findTransferPreviewPageId(config: TransferPagesSlice): Uuid | undefined {
    const pageId = findPageIdByTypeInConfig(config, PageType.TransferPreview);
    return pageId as Uuid | undefined;
}

export function isTransferRowCta(config: TransferPagesSlice, cta: Pick<Cta, "action">): boolean {
    if (cta.action.type !== "openPage") {
        return false;
    }
    const page = config.pages[cta.action.pageId];
    return page?.type === PageType.TransferForm;
}

export function isTransferRowCtaId(config: TransferPagesSlice & TransferCtasSlice, ctaId: string): boolean {
    const cta = config.ctas[ctaId];
    return cta !== undefined && isTransferRowCta(config, cta);
}

export function findTransferRowCta(config: TransferPagesSlice & TransferCtasSlice): Cta | undefined {
    return Object.values(config.ctas).find((cta) => isTransferRowCta(config, cta));
}
